<div class="container pb-4 pb-lg-5 warranty-content">
    <div class="row">
        <p class="warranty-title mb-0 pb-3 pb-lg-4">Warranty</p>
        <div class="col-12">
            <div class="warranty-table-wrapper" [innerHTML]="warrantyDetails"></div>
        </div>
    </div>
</div>